import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './FintelDefenceShowcase.css';

const FintelDefenceShowcase = () => {
  // A flat list of all static images to be displayed in the slider.
  const images = [
    // Duplicating the 3 available images to make a total of 12 for a richer slider experience.
    '/images/finteldefence/june/static/24thjune_2025_static.jpg',
    '/images/finteldefence/june/static/card_post_boost1.jpg',
    '/images/finteldefence/june/static/finalnews_post_1stjuly.jpg',
    '/images/finteldefence/june/static/24thjune_2025_static.jpg',
    '/images/finteldefence/june/static/card_post_boost1.jpg',
    '/images/finteldefence/june/static/finalnews_post_1stjuly.jpg',
    '/images/finteldefence/june/static/24thjune_2025_static.jpg',
    '/images/finteldefence/june/static/card_post_boost1.jpg',
    '/images/finteldefence/june/static/finalnews_post_1stjuly.jpg',
    '/images/finteldefence/june/static/24thjune_2025_static.jpg',
    '/images/finteldefence/june/static/card_post_boost1.jpg',
    '/images/finteldefence/june/static/finalnews_post_1stjuly.jpg',
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section id="client-showcase" className="client-showcase-section">
      <div className="container">
        <h2 className="section-title">Client Showcase: FintelDefence</h2>
        <p className="section-subtitle">A dynamic showcase of our creative social media work.</p>
        <div className="slider-container">
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index} className="slide-item">
                <img 
                  src={image} 
                  alt={`FintelDefence social media marketing success story ${index + 1} - Professional LinkedIn content creation and B2B lead generation campaign results`} 
                  className="slide-image" 
                  loading="lazy"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default FintelDefenceShowcase;
